import { render } from "./PolicyLibrary.vue?vue&type=template&id=7c53bb5a&scoped=true"
import script from "./PolicyLibrary.vue?vue&type=script&lang=js"
export * from "./PolicyLibrary.vue?vue&type=script&lang=js"

import "./PolicyLibrary.vue?vue&type=style&index=0&id=7c53bb5a&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/core_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c53bb5a"]])

export default __exports__